import { Box, Card, Text } from '@nimbus-ds/components';

function CustomLabelSkeleton() {
  return (
    <Box display="flex" flexDirection="column" gap="5">
      <Card>
        <Card.Body>
          <Box display="flex" gap="5" flexDirection="column">
            <Text.Skeleton height="30px" width="100px" />
            <Text.Skeleton fontSize="highlight" width="180px" />
            <Text.Skeleton fontSize="highlight" width="large" />
          </Box>
        </Card.Body>
      </Card>
    </Box>
  );
}

export default CustomLabelSkeleton;
